export default __webpack_public_path__ + "static/seminar-3083a474a194321debd35cb415d73b48.mp4";